import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { client } from 'utils/api-client';

export default function useRetryStripeTerminalReaderPayment(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError<{ message: string }>,
  string
> {
  const mutationFn = (invoiceId: string): Promise<AxiosResponse<void>> => {
    return client.post(`invoices/${invoiceId}/retry-terminal-payment/`);
  };

  return useMutation(mutationFn);
}
